import '../styles/Skills.scss';
import { motion } from 'framer-motion';
import { skills } from '../utils/constants';

function Skills() {
	const containerVariants = {
		hidden: { opacity: 0 },
		visible: {
			opacity: 1,
			transition: {
				staggerChildren: 0.08,
			},
		},
	};

	const itemVariants = {
		hidden: { opacity: 0, y: 20 },
		visible: { opacity: 1, y: 0 },
	};

	return (
		<section className="Skills-container">
			<motion.h3
				className="skills-heading"
				initial={{ opacity: 0, y: -20 }}
				whileInView={{ opacity: 1, y: 0 }}
				transition={{ duration: 0.8 }}
				viewport={{ once: true, amount: 0.3 }}
			>
				Technologies
			</motion.h3>
			<motion.ul
				className="tech-icons"
				variants={containerVariants}
				initial="hidden"
				whileInView="visible"
				viewport={{ once: true, amount: 0.3 }}
			>
				{skills.map(({ icon, label }, index) => (
					<motion.li
						className="tech-icon"
						key={index}
						variants={itemVariants}
						transition={{ duration: 0.4 }}
						whileHover={{ scale: 1.1 }}
						aria-label={label}
					>
						{icon}
						<small>{label}</small>
					</motion.li>
				))}
			</motion.ul>
		</section>
	);
}

export default Skills;
